// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.screener-menu {
  display: flex;
  flex-direction: row;
  height: 32px;

  background-color: #dfdfdf;
}

.screener-menu-market {
  width: 154px;
}

.screener-menu-sector {
  width: 154px;
}

.filter-icon {
  path {
    fill: var(--accent-primary);
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Screener/ScreenerMenu.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;;EAEZ,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF","sourcesContent":[".screener-menu {\n  display: flex;\n  flex-direction: row;\n  height: 32px;\n\n  background-color: #dfdfdf;\n}\n\n.screener-menu-market {\n  width: 154px;\n}\n\n.screener-menu-sector {\n  width: 154px;\n}\n\n.filter-icon {\n  path {\n    fill: var(--accent-primary);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
